<ngx-micetribe-tags
  [currentItems]="currentItems()"
  [emptyTitle]="'No language selected'"
  [noOptionsTitle]="'Create a language first'"
  [availableItems]="availableLanguages()"
  [listType]="'Languages'"
  [customLanguages]="customLanguages()"
  (selectedItemsChanged)="updateCurrentLanguages($event)"
  (addClicked)="openDialog(addLanguageDialog)"
  (tagClicked)="openEditTranslationDialog(editTranslationDialog, $event)"
  (deleteLanguageClicked)="openDialog(confirmDeleteDialog, $event)"
></ngx-micetribe-tags>
<!-- /Edit translations dialog-->
<ng-template #editTranslationDialog let-ref="dialogRef">
  <nb-card class="edit-translations tw-w-96">
    <nb-card-header>Edit translated form labels</nb-card-header>
    <nb-card-body class="d-flex flex-column justify-content-between">
      <ng-container *ngFor="let element of tempform.value.form_elements; index as i">
        <nb-form-field [ngStyle]="{ direction: editTranslationFor?.right_to_left ? 'rtl' : 'ltr', 'margin-bottom': '1rem' }">
          <label>{{ element.label }}</label>
          <input
            nbInput
            type="text"
            [ngModel]="element.options.translations[editTranslationFor.slug]"
            (ngModelChange)="onFieldNameChange($event, element)"
            [placeholder]="element.label"
          />
        </nb-form-field>
        <!-- Field values -->
        <ng-container *ngIf="element.form_element_values">
          <nb-form-field
            *ngFor="let value of element.form_element_values"
            [ngStyle]="{ direction: editTranslationFor?.right_to_left ? 'rtl' : 'ltr', 'margin-bottom': '1rem' }"
            class="mx-4"
          >
            <label>{{ value.name }}</label>
            <input
              nbInput
              type="text"
              [ngModel]="value.options.translations[editTranslationFor.slug]"
              (ngModelChange)="onFieldValueChange($event, element, value)"
              [placeholder]="element.label"
            />
          </nb-form-field>
        </ng-container>
        <!-- ./Field values -->
      </ng-container>
    </nb-card-body>
    <nb-card-footer [ngClass]="'d-flex justify-content-between'">
      <button nbButton (click)="ref.close()">Cancel</button>
      <button nbButton status="success" (click)="saveTranslation(); ref.close()">Save</button>
    </nb-card-footer>
  </nb-card>
</ng-template>
<!-- ./Edit translations dialog-->
<!-- /Add language dialog-->
<ng-template #addLanguageDialog let-ref="dialogRef">
  <nb-card>
    <nb-card-header>Add language</nb-card-header>
    <nb-card-body>
      <nb-form-field>
        <label>Language</label>
        <input nbInput type="text" [(ngModel)]="newLanguage.name" placeholder="Language" />
      </nb-form-field>
      <div class="d-flex justify-content-between align-items-end pt-2">
        <label>Is it written from right to left?</label>
        <nb-toggle [(ngModel)]="newLanguage.right_to_left" [status]="'basic'"></nb-toggle>
      </div>
    </nb-card-body>
    <nb-card-footer [ngClass]="'d-flex justify-content-between'">
      <button nbButton (click)="ref.close()">Cancel</button>
      <button nbButton status="success" (click)="addLanguage(); ref.close(); openEditTranslationDialog(editTranslationDialog, newLanguage)" [disabled]="!newLanguage.name">
        Add
      </button>
    </nb-card-footer>
  </nb-card>
</ng-template>
<!-- ./Add language dialog-->
<!-- /Confirm delete language-->
<ng-template #confirmDeleteDialog let-language let-ref="dialogRef">
  <nb-card>
    <nb-card-header>Warning</nb-card-header>
    <nb-card-body>
      <p>
        Are you sure you want to delete <strong>{{ language.name }}</strong
        >?
        <br />
        <br />
        Please note that all translations for this language will be <br />
        deleted for all of the events in your workspace.
      </p>
    </nb-card-body>
    <nb-card-footer [ngClass]="'d-flex justify-content-between'">
      <button nbButton (click)="ref.close()">Cancel</button>
      <button class="btn btn-danger" (click)="deleteLanguage(language.slug); ref.close()">Delete</button>
    </nb-card-footer>
  </nb-card>
</ng-template>
<!-- ./Confirm delete language-->
